import { Point } from 'geojson';

export const getKey = (point: Point) => point.coordinates.toString();
